var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMultiSession = function SvgMultiSession(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 19V12C49 9.79086 47.2091 8 45 8H9C6.79086 8 5 9.79086 5 12V35C5 37.2091 6.79086 39 9 39H15",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19H49",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 19,
    width: 44,
    height: 31,
    rx: 4,
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29H59",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 24C50.5 24.8284 49.8284 25.5 49 25.5C48.1716 25.5 47.5 24.8284 47.5 24C47.5 23.1716 48.1716 22.5 49 22.5C49.8284 22.5 50.5 23.1716 50.5 24Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 13.5C40.5 14.3284 39.8284 15 39 15C38.1716 15 37.5 14.3284 37.5 13.5C37.5 12.6716 38.1716 12 39 12C39.8284 12 40.5 12.6716 40.5 13.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 24C55.5 24.8284 54.8284 25.5 54 25.5C53.1716 25.5 52.5 24.8284 52.5 24C52.5 23.1716 53.1716 22.5 54 22.5C54.8284 22.5 55.5 23.1716 55.5 24Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 13.5C45.5 14.3284 44.8284 15 44 15C43.1716 15 42.5 14.3284 42.5 13.5C42.5 12.6716 43.1716 12 44 12C44.8284 12 45.5 12.6716 45.5 13.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1313 51.41L39.544 36.0704C38.369 34.1904 35.631 34.1904 34.456 36.0704L24.8687 51.41C23.6199 53.4081 25.0564 56 27.4127 56H46.5873C48.9436 56 50.3801 53.4081 49.1313 51.41Z",
    fill: "#FFB872",
    stroke: "#FFB872",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37 39.5V48",
    stroke: "#222225",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53C38 53.5523 37.5523 54 37 54C36.4477 54 36 53.5523 36 53C36 52.4477 36.4477 52 37 52C37.5523 52 38 52.4477 38 53Z",
    fill: "#222225",
    stroke: "#222225"
  })));
};
export default SvgMultiSession;